<template>
	<footer class="footer-wrapper">
		<div class="footer footer__desktop">
			<p class="footer-info">
<!--				{{ $t('footer.rights1') }}-->
			</p>
			<p class="footer-politics">
				{{ $t('footer.politics1') }}
				<a target="_blank" href="/metamsk-politic.pdf">{{ $t('footer.politics2') }}</a> <br />
				<a target="_blank" href="/consent_to_the_processing_of_personal_data.pdf"> {{ $t('footer.politics3') }}</a>
				{{ $t('footer.politics4') }}
			</p>
		</div>
		<div class="footer footer__mobile">
			<p class="footer-info">
				{{ $t('footer.politics1') }}
				<a href="/metamsk-politic.pdf" target="_blank"> {{ $t('footer.politics2') }}</a>
			</p>
			<p class="footer-info">
				<a target="_blank" href="/consent_to_the_processing_of_personal_data.pdf">{{ $t('footer.politics3') }}</a>
				{{ $t('footer.politics4') }}
			</p>
			<p class="footer-info">
<!--				{{ $t('footer.rightsMobile1') }}-->
			</p>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'FooterElement',
}
</script>

<style scoped>
.footer-wrapper {
	margin-top: auto;
	max-width: 100%;
	width: 100%;
}

.footer {
	gap: 1rem;

	display: flex;
	justify-content: space-between;
	max-width: 100%;
	width: 100%;
	align-items: flex-end;
}

.footer-info {
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	color: #8b98aa;
}

.footer-politics {
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	text-align: right;
	color: #8b98aa;
}

a {
	color: #003099;
	text-decoration: underline;
}

.footer__mobile {
	display: none;
}

@media (max-width: 650px) {
	.footer__desktop {
		display: none;
	}

	.footer__mobile {
		display: flex;
	}

	.footer {
		flex-direction: column;
		gap: 0.5rem;
	}
}

@media (max-width: 600px) {
	.footer {
		text-align: center;
		gap: 1rem;
		align-items: center;
	}

	.footer :nth-child(1) {
		order: 2;
	}

	.footer :nth-child(2) {
		order: 3;
	}

	.footer :nth-child(3) {
		order: 1;
	}
}
</style>
